import React, { FC } from 'react';

import { useWizard } from '@portals/framework';

import { OnboardingWizardContextDataType, StepId } from './types';

const OnboardingLayout: FC = () => {
  const { currentStep } = useWizard<OnboardingWizardContextDataType, StepId>();

  return <>{currentStep.component}</>;
};

export default OnboardingLayout;
